/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_NextInputs */

const en_us2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const pt_br2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const es_419_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const pt_pt2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr_fr2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_de2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const it_it2_onboarding_next = /** @type {(inputs: Onboarding_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Onboarding_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_next = /** @type {((inputs?: Onboarding_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_next(inputs)
	if (locale === "es-419") return es_419_onboarding_next(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_next(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_next(inputs)
	if (locale === "de-DE") return de_de2_onboarding_next(inputs)
	if (locale === "it-IT") return it_it2_onboarding_next(inputs)
	return en_us2_onboarding_next(inputs)
});
export { onboarding_next as "onboarding.next" }